<template>
  <div id="landing-layout" class="flex flex-col min-h-screen">
    <LandingHeader />
    <router-view :key="landingVersion" />
  </div>
</template>

<script setup>
import { computed, provide, readonly } from 'vue';
import { useRoute } from 'vue-router';
import LandingHeader from '@/components/landing/LandingHeader.vue';
import {
  resolveLandingPreviewVersion,
  LANDING_VERSION_INJECTION_KEY
} from '@/core/landing/landingVersionContext';
import { landingPreviewRuntime } from '@/config/featureFlags';

const route = useRoute();

const landingVersion = computed(() => resolveLandingPreviewVersion(
  route.query.landing_version,
  landingPreviewRuntime.allowVersionQuery
));

provide(LANDING_VERSION_INJECTION_KEY, readonly(landingVersion));
</script>